import { Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import InfoPopover from '../../../../../components/InfoPopover';
import {
  formatarCnpjCpfIMask,
  formatarMilhar,
} from '../../../../../helpers/formatador';
import { Card, ColCard, Title } from '../../styles';
import {
  CountResumo,
  GlobalStyle,
  PopOverContentLine,
  RowResumo,
  SubTitleResumo,
  TextLink,
  TitleResumo,
} from './styles';

export default function StepResumo({
  demanda,
  lotes,
  clienteEnderecoRemetente,
  clienteEnderecoDestinatario,
  clienteExpedidor,
  clienteRecebedor,
}) {
  const renderClienteResumo = informacaoCliente => {
    const info = informacaoCliente.slice(1);
    const preenchePopover = (popOverInfo = []) => {
      const popoverContent = popOverInfo.map((item, index) => (
        <PopOverContentLine key={`${item + index}`}>
          {`${item.nomeCliente} - ${formatarCnpjCpfIMask(item.cnpj)}`}
        </PopOverContentLine>
      ));
      return popoverContent;
    };

    return (
      <InfoPopover
        content={preenchePopover(info)}
        trigger="click"
        placement="bottom"
        color="rgba(0, 0, 0, 0.75)"
      >
        <CountResumo>
          {info.length < 1 ? '' : <TextLink underline>Ver todos</TextLink>}
        </CountResumo>
      </InfoPopover>
    );
  };

  return (
    <>
      <GlobalStyle />
      <Row style={{ height: '90%' }}>
        <ColCard span={12} className="height-71">
          <Card className="height-71">
            <Row>
              <Title>Resumo</Title>
            </Row>

            <RowResumo>
              <TitleResumo>Produto</TitleResumo>
              <SubTitleResumo>{demanda.descricaoProduto}</SubTitleResumo>
            </RowResumo>

            <RowResumo>
              <TitleResumo>Cliente Pagador</TitleResumo>
              <SubTitleResumo>
                {`${demanda.razao_social} - ${formatarCnpjCpfIMask(
                  demanda.cnpj
                )}`}
              </SubTitleResumo>
            </RowResumo>

            <RowResumo>
              <TitleResumo>Remetente</TitleResumo>
              <SubTitleResumo>
                {`${
                  clienteEnderecoRemetente[0].nomeCliente
                } - ${formatarCnpjCpfIMask(clienteEnderecoRemetente[0].cnpj)}`}
                &nbsp;
                {renderClienteResumo(clienteEnderecoRemetente)}
              </SubTitleResumo>
            </RowResumo>

            <RowResumo>
              <TitleResumo>Destinatário</TitleResumo>
              <SubTitleResumo>
                {`${
                  clienteEnderecoDestinatario[0].nomeCliente
                } - ${formatarCnpjCpfIMask(
                  clienteEnderecoDestinatario[0].cnpj
                )}`}
                &nbsp;
                {renderClienteResumo(clienteEnderecoDestinatario)}
              </SubTitleResumo>
            </RowResumo>

            <RowResumo>
              <TitleResumo>Expedidor</TitleResumo>
              <SubTitleResumo>
                {`${clienteExpedidor[0].nomeCliente} - ${formatarCnpjCpfIMask(
                  clienteExpedidor[0].cnpj
                )}`}
                &nbsp;
                {renderClienteResumo(clienteExpedidor)}
              </SubTitleResumo>
            </RowResumo>

            <RowResumo>
              <TitleResumo>Recebedor</TitleResumo>
              <SubTitleResumo>
                {`${clienteRecebedor[0].nomeCliente} - ${formatarCnpjCpfIMask(
                  clienteRecebedor[0].cnpj
                )}`}
                &nbsp;
                {renderClienteResumo(clienteRecebedor)}
              </SubTitleResumo>
            </RowResumo>

            <RowResumo>
              <TitleResumo>Demanda</TitleResumo>
              <SubTitleResumo style={{ marginBottom: 0 }}>
                {`${lotes.length} ${lotes.length > 1 ? 'Lotes' : 'Lote'} `}
              </SubTitleResumo>

              <SubTitleResumo style={{ marginBottom: 0 }}>
                {`${formatarMilhar(demanda.volumeTotal)} ${
                  demanda.volumeTotal > 1 ? 'Toneladas' : 'Tonelada'
                } `}
              </SubTitleResumo>
              <SubTitleResumo>
                {`${formatarMilhar(demanda.cadenciaDiariaTotal)} ${
                  demanda.cadenciaDiariaTotal > 1
                    ? 'Tons de cadência diária'
                    : 'Ton de cadência diária'
                } `}
              </SubTitleResumo>
            </RowResumo>
          </Card>
        </ColCard>
      </Row>
    </>
  );
}

StepResumo.propTypes = {
  demanda: PropTypes.objectOf(PropTypes.any).isRequired,
  lotes: PropTypes.arrayOf(PropTypes.any).isRequired,
  clienteEnderecoRemetente: PropTypes.arrayOf(PropTypes.any).isRequired,
  clienteEnderecoDestinatario: PropTypes.arrayOf(PropTypes.any).isRequired,
  clienteExpedidor: PropTypes.arrayOf(PropTypes.any).isRequired,
  clienteRecebedor: PropTypes.arrayOf(PropTypes.any).isRequired,
};
